import { useHandler } from "@chatbotgang/etude/react/useHandler";
import Stack from "@mui/material/Stack";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Modal } from "@/components/Modal";
import { Typography } from "@/components/Typography";

interface DeleteLineAdsAccountModalProps {
  accountName: string;
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteLineAdsAccountModal: React.FC<DeleteLineAdsAccountModalProps> =
  function DeleteLineAdsAccountModal({
    open,
    isLoading,
    onClose,
    onConfirm,
    accountName,
  }) {
    const { t } = useTranslation();
    const handleClose = useHandler(() => {
      if (isLoading) return;
      onClose();
    });

    return (
      <Modal
        open={open}
        handleClose={handleClose}
        title={t(
          "applications.lineAds.deleteAccountModal.title",
          "Remove ad account?",
        )}
        footer={
          <Stack direction="row" justifyContent="flex-end" gap="12px">
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              {t("common.cancel")}
            </Button>
            <Button
              variant="danger"
              onClick={onConfirm}
              loading={isLoading}
              disabled={isLoading}
            >
              {t("common.delete")}
            </Button>
          </Stack>
        }
      >
        <Typography variant="body" color={theme.colors.staticFgBody}>
          {t(
            "applications.lineAds.deleteAccountModal.message",
            "MAAC segments can no longer use {{name}}. Reloading the accounts brings it back.",
            { name: accountName },
          )}
        </Typography>
      </Modal>
    );
  };
